import { LoginData } from './types';
import {
  LOGIN_USER,
  LOGOUT_USER,
  FETCH_LOGGED_USER,
  SET_TOKEN,
} from './constants';
import { Commit, Module } from 'vuex';
import { State } from '..';
import { AuthState } from '../auth/types';
import { User } from '@/models/user';
import getLoggedUser from '@/api/auth/getLoggedUser';
import { AUTH_TOKEN } from '@/constants';
// import router from '@/router';

interface Context {
  commit: Commit;
  state: AuthState;
}

const authModule: Module<AuthState, State> = {
  state: {
    user: null,
    loggedIn: false,
    token: '',
  },
  mutations: {
    [LOGIN_USER](state: AuthState, loginData: LoginData) {
      state.user = loginData.user;
      state.loggedIn = true;
      state.token = loginData.token;
    },

    [LOGOUT_USER](state: AuthState) {
      state.user = null;
      state.loggedIn = false;
      state.token = '';
    },
    [FETCH_LOGGED_USER](state: AuthState, data: { user: User }) {
      state.user = data.user;
      state.loggedIn = true;
    },
    [SET_TOKEN](state: AuthState, token: string) {
      state.token = token;
    },
  },
  actions: {
    [FETCH_LOGGED_USER]: async ({ commit, state }: Context) => {
      const token = localStorage.getItem(AUTH_TOKEN);

      if (token) {
        commit('SET_TOKEN', token);
      }

      if (!state.token) {
        return;
      }

      const user = await getLoggedUser();

      return commit('FETCH_LOGGED_USER', user);
    },
    [LOGOUT_USER]: async ({ commit }) => {
      commit('LOGOUT_USER');
      localStorage.removeItem(AUTH_TOKEN); // adjust the key if needed
    },
  },
  getters: {
    currentUser: (state) => state.user,
    isLoggedIn: (state) => state.loggedIn,
    userToken: (state) => state.token,
    userRole: (state) => state.user?.role || null, // 👈 Add this
  },
};

export default authModule;
